module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Players")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Pentatheon,")]), _vm._v(" the five paramount “gods” of the Vales:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Visek")]), _vm._v(" the Parent")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Eltiana")]), _vm._v(" the Lady")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Karzon")]), _vm._v(" the Man")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Astina")]), _vm._v(" the Maiden")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tion")]), _vm._v(" the Youth.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("They acquire mana from the native population by terror or deception, and while away the centuries playing the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Great Game")]), _vm._v(" with human pawns.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Their many minions are known as avatars,"), _c('span', {
    staticClass: "footnoteRef",
    attrs: {
      "id": "footnote1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/footnote1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" especially the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chamber,")]), _vm._v(" who are the worst of them, led by:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Zath,")]), _vm._v(" the “god” of death. Although officially an avatar of Karzon, he has become dominant by empowering murderous devotees known as "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("reapers")]), _vm._v(" to offer him human sacrifice, a most potent source of mana.")])]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry"
  }, [_vm._v("The "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Service,")]), _vm._v(" a group of altruistic strangers who are attempting to overthrow this malignant tyranny by promoting a new faith, the Church of the Undivided.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry"
  }, [_vm._v("The "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Filoby Testament,")]), _vm._v(" a book of prophecy that predicts the coming of the Liberator who will bring death to Death, but identifies him only as the son of Cameron Exeter, a member of the Service in the late nineteenth century.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('p', {
    staticClass: "bibliographyEntry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Head Office,")]), _vm._v(" an organization of strangers on Earth who frequently cooperate with the Service on Nextdoor and who sheltered Cameron Exeter when he fled back to Earth to escape Zath’s efforts to break the chain of prophecy by murdering him.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry"
  }, [_vm._v("The "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Blighters,")]), _vm._v(" another group of strangers on Earth, who will sometimes attend to the Chamber’s dirty work there, and who in 1912 hunted down Exeter and his wife at Nyagatha in Kenya and slew them.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Edward Exeter,")]), _vm._v(" the only son of Cameron and Rona Exeter, and thus the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Liberator")]), _vm._v(" foretold.")])])]), _c('a', {
    attrs: {
      "id": "page02"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8339f7f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/futureindefinite_fm01.vue
// module id = 81
// module chunks = 0